export default {
  'meta': {
    'langName': 'LATVIAN',
    'lang': 'Latviešu'
  },
  'title': 'PRECES ATSAUKŠANA BASKETBOLA GROZS B900 BOX NBA TARMAK',
  'description': 'Labdien!\n \n \n Jūs nesen iegādājāties Tarmak B900 BOX NBA basketbola grozu, un mēs pateicamies par Jūsu pirkumu.\n \n Kā daļu no mūsu pastāvīgās apņemšanās nodrošināt produktu kvalitāti un drošību, DECATHLON komanda ir konstatējusi iespējamu risku, ka basketbola groza stienis var nokrist vertikāli, ja augstuma regulēšanas kloķis tiek noņemts un prece tiek lietota.\n \n Lūdzam jūs atbildēt uz dažiem jautājumiem, lai mēs varētu piedāvāt jums atbilstošu drošības risinājumu jūsu produktam.\n \n Atvainojamies par sagādātajām neērtībām un pateicamies par jūsu uzticību.\n \n DECATHLON',
  'emailConfirmation': {
    'title': 'Vispirms, lūdzu, apstipriniet savu e-pasta adresi un dzīvesvietas valsti:'
  },
  'fields': {
    'country': 'Valsts',
    'address': 'Pasta adrese',
    'email': 'Pasta adrese',
    'phonePrefix': 'Tālruņa numura kods',
    'phone': 'Tālruņa numurs',
    'validations': {
      'phoneOrEmail': 'Lūdzu, norādiet vismaz e-pasta adresi vai tālruņa numuru.',
      'email': 'Lūdzu, ievadiet derīgu e-pasta adresi',
      'phone': 'Lūdzu, ievadiet derīgu tālruņa numuru'
    },
    'firstName': 'Uzvārds',
    'lastName': 'Vārds',
    'deliveryAddress': 'Sūtījuma piegādes adrese',
    'additionalAddress': 'Adreses papildu informācija',
    'city': 'Pilsēta',
    'zip': 'Pasta indekss',
    'choose': 'Atlasīt',
    'required': 'Šis lauks ir obligāti jāaizpilda'
  },
  'ownerCheck': {
    'title': 'Vai jums joprojām pieder viens vai vairāki B900 BOX NBA basketbola grozi?'
  },
  'yes': 'JĀ',
  'no': 'NĒ',
  'ownerChanged': {
    'title': 'Vai jums ir pašreizējā(-o) īpašnieka(-u) kontaktinformācija?',
    'confirmation': 'Kungs/kundze,\n \n Paldies par jūsu dalību šajā kvalitātes iniciatīvā.\n \n Atvainojamies par sagādātajām neērtībām un pateicamies par jūsu uzticību.\n \n DECATHLON'
  },
  'recall': {
    'title': 'Lūdzu, norādiet savu basketbola grozu skaitu, ņemot vērā uzstādītā kloķa veidu',
    'descriptionRed': 'Basketbola grozs ar noņemamu sarkanu kloķi',
    'descriptionBlack': 'Basketbola grozs ar fiksētu melnu kloķi',
    'quantity': 'Daudzums',
    'notConcerned': 'Kungs/kundze,\n \n Paldies par jūsu dalību šajā kvalitātes iniciatīvā.\n \n Varat būt droši, ka atsaukšanas process neietekmē jūsu Tarmak B900 BOX NBA basketbola grozu. Tā lietošana ir droša.\n \n Atvainojamies par sagādātajām neērtībām un pateicamies par jūsu uzticību.\n \n DECATHLON',
    'concernedProductQuantity': 'Neatbilstošā produkta daudzums:',
    'concernedProductLabel': 'Neatbilstošais produkts:',
    'confirmation': 'Paldies, ka aizpildījāt šo veidlapu. Jūsu pieprasījums ir veiksmīgi reģistrēts.\n \n Mēs nosūtīsim jums izsekošanas numuru jūsu komplekta piegādei, cik drīz vien iespējams.\n \n Vēlam jums lielisku dienu.\n \n DECATHLON'
  },
  'repair': {
    'title': 'Remonts ar jūsu līdzdalību',
    'description': 'Esam konstatējuši risku, ka noteiktu TARMAK B900 BOX NBA basketbola grozu (kods: 4239136) stienis var nokrist vertikāli, ja kloķis tiek noņemts un izstrādājums tiek izmantots.\n Balstoties uz jūsu atbildi, šķiet, ka šis risks ietekmē jūsu produktu.\n \n Tāpēc lūdzam nekavējoties pārtraukt tā lietošanu un piedāvājam palīdzību kloķa pielāgošanā, lai jūs varētu droši lietot savu produktu.\n Esiet droši, šim remontam nav nepieciešamas īpašas zināšanas — viss ir skaidri izklāstīts zemāk esošajā videoklipā un lietošanas instrukcijā:',
    'videoLink': 'Video saite',
    'docLink': 'Paziņojuma saite',
    'callToAction': 'Noklikšķiniet šeit, lai saņemtu bezmaksas remonta komplektu',
    'warranty': 'Visam procesam ir mūsu 5 gadu garantija.'
  },
  'repairRequest': {
    'title': 'Lūdzu, ievadiet tālāk norādīto informāciju, lai jūsu bezmaksas komplektu varētu nosūtīt uz jūsu izvēlēto adresi:'
  },
  'form': {
    'submit': 'Nākamais'
  },
  'status': 'Translation validated by COUNTRY'
} as const
